import {EqualityRelation} from '../enums/equality-relation';
import {SearchColumn} from '../enums/search-column';
import {DasqlNode} from './dasql-node';

export abstract class ConditionDasqlNode extends DasqlNode {
  constructor(private column: SearchColumn, private relation: EqualityRelation, private arg: string) {
    super();
  }

  public emit(): string {
    return `${this.column} ${this.relation} '${this.escapeSingleQuotes(this.arg)}'`;
  }
}
